/**
 * Error handling utilities for AI module
 */

export function getErrorMessage(error: any, defaultMessage: string = 'Operation failed'): string {
  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object') {
    return error.message || error.error || defaultMessage;
  }

  return defaultMessage;
}

export function formatError(error: any): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (typeof error === 'object' && error !== null) {
    return error.message || JSON.stringify(error);
  }

  return 'An unknown error occurred';
}

/**
 * Extract error message from RTK Query error responses.
 * Safely handles FetchBaseQueryError, SerializedError, and unknown shapes.
 */
export function extractApiError(error: unknown, fallback: string = 'Operation failed'): string {
  if (!error) return fallback;

  if (typeof error === 'string') return error;

  if (typeof error === 'object' && error !== null) {
    const err = error as Record<string, any>;
    // RTK Query FetchBaseQueryError shape: { data: { message: string } }
    if (err.data?.message) return err.data.message;
    // SerializedError shape: { message: string }
    if (err.message) return err.message;
    // Fallback for other object shapes
    if (err.error) return String(err.error);
  }

  return fallback;
}
